import React from "react";
import { Navigate, Outlet } from "react-router-dom";
export default function RequireCockpitAuth() {
  const token = localStorage.getItem("adminToken");
  if (!token) return <Navigate to="/cockpit/login" replace />;
  return <Outlet />;
}
